import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CourseCard from "../../components/CourseCard.jsx";
import { getCoursesList } from "../../services/course.service.js";
import { AiOutlinePlus } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";
import Toast from "../../components/Toast.jsx";
import Constants from "../../data/Constants.js";
import Utils from "../../utils/index.js";
import { useNavigate, useOutletContext } from "react-router-dom";
import GroupCard from "components/GroupCard.jsx";
import Seperator from "components/Seperator.jsx";
function Courses(props) {
  const navigate = useNavigate();
  const { setProgress, setToast, isRefreshed, isLoading } = useOutletContext();
  const [courses, setCourses] = useState(false);
  const [groupCourses, setGroupCourses] = useState({});
  const [filters, setFilters] = useState({
    type: "All",
    status:"All",
    sortByGroup: true,
  });
  useEffect(() => {
    async function api() {
      try {
        setProgress(true);
        const data = await getCoursesList({ ...filters });
        setProgress(false);
        if (data) {
          const tempGroup = {};
          for (let course of data) {
            if (!tempGroup[course.groupCourseId]) {
              tempGroup[course.groupCourseId] = [];
            }
            tempGroup[course.groupCourseId].push(course);
          }
          setGroupCourses(tempGroup);
          setCourses(data);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error
        setProgress(false);
        setToast({ error: true, message: Utils.CustomErrorMessage(error) });
      }
    }
    api();
  }, [filters, isRefreshed]);

  return (
    <>
      <div className="flex my-2 md:items-center md:flex-row flex-col gap-4">
        <div className="md:ml-auto flex items-center gap-2 justify-center">
          <Select
            value={filters.type}
            size="small"
            onChange={(e) => {
              setFilters({ ...filters, type: e.target.value, });
            }}
          >
            <MenuItem value="All">All Courses</MenuItem>

            {Constants.Course.Types.map((option, index) => {
              return (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              );
            })}
          </Select>
          <Select
            value={filters.status}
            size="small"
            onChange={(e) => {
              setFilters({ ...filters, status: e.target.value });
            }}
          >
            <MenuItem value="All">All Courses</MenuItem>

            {Constants.Course.Status.map((option, index) => {
              return (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              );
            })}
          </Select>

          <Button
            variant="contained"
            onClick={() => {
              navigate("/dashboard/courses/edit");
            }}
          >
            Create Course +
          </Button>
        </div>
      </div>
      <Grid container className="md:justify-start justify-center">
        {!courses && isLoading ? (
          <React.Fragment>
            <Skeleton
              className="m-2"
              style={{ width: "300px", height: "300px" }}
            />
            <Skeleton
              className="m-2"
              style={{ width: "300px", height: "300px" }}
            />
            <Skeleton
              className="m-2"
              style={{ width: "300px", height: "300px" }}
            />
          </React.Fragment>
        ) : (
          Object.keys(groupCourses).map((gc, index) => {
            const courses2 = groupCourses[gc];

            return (
              <GroupCard key={index}>
                {courses2.map((course, index) => {
                  return (
                    <CourseCard key={index} course={course} className="m-2" />
                  );
                })}
              </GroupCard>
            );
          })
        )}

        <Card
          sx={{ width: "300px", minHeight: "250px" }}
          color="#000"
          className=" m-2 cursor-pointer"
          onClick={() => {
            navigate("/dashboard/courses/edit");
          }}
        >
          <CardContent className="bg-primary h-full flex ">
            <div className=" text-white  m-auto font-bold uppercase active:animate-ping">
              <AiOutlinePlus size={80} className="m-4" />
              Create Course
            </div>
          </CardContent>
        </Card>
      </Grid>

      {/* <Seperator label="Groups" />
      <Grid container className="md:justify-start justify-center">

      </Grid> */}
    </>
  );
}

export default Courses;
